import { render, staticRenderFns } from "./abs_stacked_chart.vue?vue&type=template&id=6a652cf4&scoped=true&"
import script from "./abs_stacked_chart.vue?vue&type=script&lang=js&"
export * from "./abs_stacked_chart.vue?vue&type=script&lang=js&"
import style0 from "./abs_stacked_chart.vue?vue&type=style&index=0&id=6a652cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a652cf4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a652cf4')) {
      api.createRecord('6a652cf4', component.options)
    } else {
      api.reload('6a652cf4', component.options)
    }
    module.hot.accept("./abs_stacked_chart.vue?vue&type=template&id=6a652cf4&scoped=true&", function () {
      api.rerender('6a652cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade_data/abs_graphs/abs_stacked_chart.vue"
export default component.exports